// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"dfea8357","739":"a356a51f"}[chunkId] + ".chunk.js";
};